module.exports = __webpack_public_path__ + "application/templates/default/inner/legal-partner/legal-partner.template.html";